import React, { useState, forwardRef, useRef, useImperativeHandle, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addItem } from '../../actions/ticket-action';
import PropTypes from 'prop-types';
import { Link } from '@fluentui/react';
import * as service from '../../services/sTicket/ticket.service';

const AddForm = forwardRef(({ addItemConnect, preSetData }, ref) => {

  
  const [formData, setFormData] = useState({
    id: -1,
    subject: preSetData.subject || '',
    category: preSetData.category || 'Billing',
    assignee: preSetData.assignee || 'Erwin',
    priority: preSetData.priority || 'Normal',
    status: preSetData.status || 'Open',
  });
  

  const [categories, setCategories] = useState(['Billing', 'Dev', 'Marketing', 'Service']);
  const [assignees, setAssignees] = useState(['Erwin', 'Jessica', 'George', 'Jose', 'Luke']);
  const [priorities, setPriorities] = useState(['Normal', 'Low', 'Medium', 'High']);


  // Define una referencia para el formulario
  const formRef = useRef(null);

  const handleChange = e => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const { subject, category, assignee, priority } = formData;
    if (subject === '') {
      alert("Subject can't be empty");
    } else {
      //setHasSave(true);
      service.addTicket(formData).then(async (response) => {
          const addedItem = response.data.data; // Suponiendo que la API devuelve el nuevo elemento creado      
          addItemConnect(addedItem);
          formReset();              
      }).catch(() => {        
        formReset();    
      });
      // addItemConnect(item);
      // formReset();      
    }
  };



  const formReset = () => {
    setFormData({
      subject: '',
      category: 'Billing',
      assignee: 'Erwin',
      priority: 'Normal',
    });
  };

  // Método para ejecutar la lógica de submit
  const handleFormSubmit = () => {
    if (formRef.current) {      
      handleSubmit({ preventDefault: () => {} });
    }
  };

  // Exponer el método handleFormSubmit mediante useImperativeHandle
  useImperativeHandle(ref, () => ({
    handleFormSubmit: handleFormSubmit
  }));

  const optionGenerator = optionList => {
    return optionList.map(opt => (
      <option key={opt} value={opt}>
        {opt}
      </option>
    ));
  };

  const { subject, category, assignee, priority } = formData;

  return (
    <div className="container-sm">
      <form ref={formRef} onSubmit={handleSubmit}>
        <div className="modal-body">
          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <textarea
              className="form-control"
              id="subject"
              rows="5"
              value={subject}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="category">Category</label>
            <select
              className="form-control"
              id="category"
              value={category}
              onChange={handleChange}
            >
              {optionGenerator(categories)}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="assignee">Assignee</label>
            <select
              className="form-control"
              id="assignee"
              value={assignee}
              onChange={handleChange}
            >
              {optionGenerator(assignees)}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="priority">Priority</label>
            <select
              className="form-control"
              id="priority"
              value={priority}
              onChange={handleChange}
            >
              {optionGenerator(priorities)}
            </select>
          </div>
        </div>
      </form>
    </div>
  );
});

AddForm.propTypes = {
  addItemConnect: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  addItemConnect: bindActionCreators(addItem, dispatch),
});

export default connect(null, mapDispatchToProps, null, { forwardRef: true })(AddForm);